import {
  deserialize,
  serializable,
} from 'serializr';
import { Deserializable } from '@models/deserializable';

export class QtestFieldAllowedValueModel implements Deserializable {
  @serializable
  public id: string;
  @serializable
  public label: string;
  @serializable
  public value: string;
  @serializable
  public order: number;
  @serializable
  public isDefault: boolean;
  @serializable
  public isActive: boolean;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(QtestFieldAllowedValueModel, input));
  }
}
